import type { SpaceOverviewSwitcherQuery$data } from '../../__generated__/SpaceOverviewSwitcherQuery.graphql.ts';

export const MOCK_DATA: SpaceOverviewSwitcherQuery$data = {
	confluence_smartSpaceOverview: {
		summary: {
			body: 'Mock summary for testing.',
		},
		faq: {
			entries: [
				{
					question: 'What is our authentication migration timeline?',
					answer:
						'Our authentication migration will follow a phased rollout to minimize risk and disruption. We will complete discovery and design in Q1, build and test the new framework in Q2, begin a pilot in early Q3, and expand migration in waves through late Q3 and Q4. Legacy authentication systems will be decommissioned once adoption and stability targets are met.',
					followUpQuestions: [
						'What risks or dependencies could impact the migration timeline?',
						'How will customers be notified about authentication changes?',
					],
					sources: [
						{
							content: {
								id: '1',
								title: 'Authentication Migration Plan – FY Roadmap (Co…',
								excerpt:
									'Background In the original plan for the deployment of JCICD Portal Frontend as a Bifrost static application, the service uses Atlassian ID to authenticate the user. This authentication path is strongly recommended by Bifrost developer documentation and is employed by many internal platforms, such as Atlassian Elevate and Apex Wrapped.',
								embeddedProduct: 'Confluence',
								links: {
									webui: '/spaces/ENG/pages/auth-migration-plan',
								},
							},
						},
						{
							content: {
								id: '2',
								title: 'Identity Platform Upgrade – Architecture Overvie…',
								excerpt:
									"Latest updates Atlassian's Identity Platform is used by Atlassian cloud products and services to accurately verify who someone is (authentication) and to determine what they have access to (authorization).",
								embeddedProduct: 'Jira',
								links: {
									webui: '/spaces/ENG/pages/identity-platform-upgrade',
								},
							},
						},
						{
							content: {
								id: '3',
								title: 'Security Assistant (Trust Eng) – Internal Apps…',
								excerpt:
									'This is the main structured tracker for People & Legal Tech internal services moving onto the Okta paved path (UCT + rollcall, etc.). Key points:',
								embeddedProduct: 'Loom',
								links: {
									webui: '/spaces/ENG/pages/security-assistant',
								},
							},
						},
					],
				},
				{
					question: 'What are the Q1 2026 product priorities?',
					answer:
						'The Q1 2026 priorities focus on platform stability improvements, rolling out the new design system, and launching the AI-powered search experience to all customers.',
					followUpQuestions: [
						'Which teams are responsible for each priority?',
						'What are the key milestones for Q1?',
					],
					sources: [
						{
							content: {
								id: '4',
								title: 'Q1 2026 Product Roadmap',
								excerpt: '',
								embeddedProduct: 'Confluence',
								links: {
									webui: '/spaces/PROD/pages/q1-2026-roadmap',
								},
							},
						},
					],
				},
				{
					question: 'How do I access the new design system components?',
					answer:
						'The new design system components are available through the shared component library. You can install them via the internal package registry and reference the Storybook documentation for usage examples.',
					followUpQuestions: ['What components are available in the latest release?'],
					sources: [
						{
							content: {
								id: '5',
								title: 'Design System Component Library',
								excerpt: '',
								embeddedProduct: 'External',
								links: {
									webui: '/spaces/DESIGN/pages/component-library',
								},
							},
						},
					],
				},
			],
		},
		topLinks: {
			contentId: 'example-content',
			lastRefreshed: null,
			links: [{ url: 'https://example.atlassian.net/wiki', title: 'Example doc', isPinned: true }],
		},
	},
};
